export default __webpack_public_path__ + "static/quote-card-3-1427ba8a2b46ed094f1a12a34e627194.png";